export const DEFAULT_NOTIFICATIONS = 0

const USER_EDIT_LINK = {
  text: 'NAVIGATION_USER_COCHES_EDIT_TEXT',
  url: 'NAVIGATION_USER_COCHES_EDIT_URL'
}

const USER_FAVORITES_LINK = {
  text: 'NAVIGATION_USER_COCHES_FAVORITES_TEXT',
  url: 'NAVIGATION_USER_COCHES_FAVORITES_URL'
}

const USER_ALERTS_LINK = {
  text: 'NAVIGATION_USER_COCHES_ALERTS_TEXT',
  url: 'NAVIGATION_USER_COCHES_ALERTS_URL'
}

const USER_MESSAGES_LINK = {
  text: 'NAVIGATION_USER_COCHES_MESSAGES_TEXT',
  url: 'NAVIGATION_USER_COCHES_MESSAGES_URL'
}

export const USER_ADS_LINK = {
  text: 'NAVIGATION_USER_COCHES_ADS_TEXT',
  url: 'NAVIGATION_USER_COCHES_ADS_URL'
}

const USER_LOGOUT_LINK = {
  text: 'NAVIGATION_USER_COCHES_LOG_OUT_TEXT',
  url: 'NAVIGATION_USER_COCHES_LOG_OUT_URL',
  // Tracks `Signed Out` and clears the Segment identity cookies (ajs_user_id) before the browser
  // leaves for the /logout.aspx monolith page, which has no React tracking of its own.
  // No `event` key on purpose: an event would be dispatched on the next frame and lost to the navigation.
  trackingData: {reset: true}
}

export const MOBILITY_SERVICES_ENTRYPOINT_TEXT = 'NAVIGATION_MAIN_STATIONS_SEARCH_COCHES_TEXT'

export const NAVIGATION_NEWS_BLOG = {
  text: 'NAVIGATION_MAIN_NEWS_COCHES_BLOG_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_COCHES_BLOG_URL'
}
export const NAVIGATION_NEWS_BLOG_TESTS = {
  text: 'NAVIGATION_MAIN_NEWS_COCHES_BLOG_TEST_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_COCHES_BLOG_TEST_URL'
}
export const NAVIGATION_NEWS_TRENDS = {
  text: 'NAVIGATION_MAIN_NEWS_COCHES_TRENDS',
  url: 'NAVIGATION_MAIN_NEWS_COCHES_TRENDS_URL'
}
export const NAVIGATION_NEWS_MOST_NEW = {
  text: 'NAVIGATION_MAIN_NEWS_COCHES_BLOG_MOST_NEW_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_COCHES_BLOG_MOST_NEW_URL'
}
export const NAVIGATION_NEWS_COMPARATIVE = {
  text: 'NAVIGATION_MAIN_NEWS_COCHES_BLOG_COMPARATIVE_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_COCHES_BLOG_COMPARATIVE_URL'
}
export const NAVIGATION_NEWS_VIDEOS = {
  text: 'NAVIGATION_MAIN_NEWS_COCHES_BLOG_VIDEOS_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_COCHES_BLOG_VIDEOS_URL'
}
export const NAVIGATION_NEWS_TIPS = {
  text: 'NAVIGATION_MAIN_NEWS_COCHES_TIPS',
  url: 'NAVIGATION_MAIN_NEWS_COCHES_TIPS_URL'
}
export const NAVIGATION_NEWS_IMAGES_GALLERY = {
  text: 'NAVIGATION_MAIN_NEWS_COCHES_IMAGES_GALLERY_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_COCHES_IMAGES_GALLERY_URL'
}

/**
 * @exports main
 */
export const main = [
  {
    icon: 'car',
    label: 'NAVIGATION_MAIN_SEARCH_TITLE',
    menu: [
      {
        title: 'NAVIGATION_MAIN_SEARCH_CARS_TITLE', // Coches
        links: [
          {
            text: 'NAVIGATION_MAIN_SEARCH_CARS_SECOND_HAND_TEXT', // Coches de segunda mano
            url: 'NAVIGATION_MAIN_SEARCH_CARS_SECOND_HAND_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SEARCH_CARS_KM_0_TEXT', // Coches km 0
            url: 'NAVIGATION_MAIN_SEARCH_CARS_KM_0_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SEARCH_CARS_NEW_TEXT', // Coches nuevos
            url: 'NAVIGATION_MAIN_SEARCH_CARS_NEW_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SEARCH_CARS_SUBSCRIPTION_PRIVATES_TEXT', // Renting y suscripción
            url: 'NAVIGATION_MAIN_SEARCH_CARS_SUBSCRIPTION_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SEARCH_CARS_SUBSCRIPTION_BUSINESS_TEXT', // Renting para empresas
            url: 'NAVIGATION_MAIN_SEARCH_CARS_SUBSCRIPTION_BUSINESS_URL'
          }
        ]
      },
      {
        title: 'NAVIGATION_MAIN_MORE_VEHICLES_TITLE',
        links: [
          {
            text: 'NAVIGATION_MAIN_MORE_VEHICLES_VANS_AND_COMMERCIAL_TEXT',
            url: 'NAVIGATION_MAIN_MORE_VEHICLES_VANS_AND_COMMERCIAL_URL'
          },
          {
            text: 'NAVIGATION_MAIN_MORE_VEHICLES_CLASSIC_AND_COMPETITION_TEXT',
            url: 'NAVIGATION_MAIN_MORE_VEHICLES_CLASSIC_AND_COMPETITION_URL'
          },
          {
            text: 'NAVIGATION_MAIN_MORE_VEHICLES_AUTOCARAVANS_AND_TRAILERS_TEXT',
            url: 'NAVIGATION_MAIN_MORE_VEHICLES_AUTOCARAVANS_AND_TRAILERS_URL'
          },
          {
            text: 'NAVIGATION_MAIN_MORE_VEHICLES_CARS_WITHOUT_LICENSE_TEXT',
            url: 'NAVIGATION_MAIN_MORE_VEHICLES_CARS_WITHOUT_LICENSE_URL'
          }
        ]
      },
      {
        title: 'NAVIGATION_MAIN_SEARCH_PLACES_COCHES_TITLE',
        links: [
          {
            text: 'NAVIGATION_MAIN_DEALERS_SEARCH_COCHES_TEXT',
            url: 'NAVIGATION_MAIN_DEALERS_SEARCH_COCHES_URL'
          },
          {
            isExternal: true,
            text: MOBILITY_SERVICES_ENTRYPOINT_TEXT,
            url: 'NAVIGATION_MAIN_STATIONS_SEARCH_COCHES_URL'
          }
        ]
      }
    ]
  },
  {
    icon: 'play',
    label: 'NAVIGATION_MAIN_INFO_COCHES_TITLE', // Pruebas e información
    menu: [
      {
        title: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_TITLE',
        links: [
          {
            text: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_MAKE_MODEL_SEARCH_TEXT', // Información y precios de coches nuevos
            url: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_MAKE_MODEL_SEARCH_URL'
          },
          {
            text: 'NAVIGATION_MAIN_TECHNICAL_DATA_SEARCH_TEXT', // Buscador de fichas técnicas
            url: 'NAVIGATION_MAIN_TECHNICAL_DATA_SEARCH_URL'
          },
          {
            text: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_MAKE_SIZES_TEXT', // Medidas de coches
            url: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_MAKE_SIZES_URL'
          },
          {
            text: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_COMPARISON_TEXT', // Comparador de coches
            url: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_COMPARISON_URL'
          }
        ]
      },
      {
        title: 'NAVIGATION_MAIN_NEWS_COCHES_TITLE',
        links: [
          NAVIGATION_NEWS_BLOG,
          NAVIGATION_NEWS_BLOG_TESTS,
          NAVIGATION_NEWS_TRENDS,
          NAVIGATION_NEWS_MOST_NEW,
          NAVIGATION_NEWS_COMPARATIVE,
          NAVIGATION_NEWS_VIDEOS,
          NAVIGATION_NEWS_TIPS,
          NAVIGATION_NEWS_IMAGES_GALLERY
        ]
      }
    ]
  },
  {
    icon: 'calculator',
    label: 'NAVIGATION_MAIN_SERVICES_COCHES_TITLE',
    menu: [
      {
        links: [
          {
            text: 'NAVIGATION_MAIN_SERVICES_COCHES_SEARCH_ADVICES_TEXT',
            url: 'NAVIGATION_MAIN_SERVICES_COCHES_SEARCH_ADVICES_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SERVICES_COCHES_SEARCH_FINANCING_TEXT',
            url: 'NAVIGATION_MAIN_SERVICES_COCHES_SEARCH_FINANCING_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SERVICES_COCHES_PRICE_CALCULATOR_TEXT',
            url: 'NAVIGATION_MAIN_SERVICES_COCHES_PRICE_CALCULATOR_URL'
          },
          {
            isExternal: true,
            text: 'NAVIGATION_MAIN_SERVICES_COCHES_CAR_REPORT_TEXT',
            url: 'NAVIGATION_MAIN_SERVICES_COCHES_CAR_REPORT_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SERVICES_COCHES_INSURANCE_TEXT',
            url: '/seguros',
            trackingData: {
              event: 'Event Fired',
              data: {
                channel: 'marketplace insurances',
                event_id: 'insurances home menu clicked'
              }
            }
          },
          {
            isExternal: true,
            text: 'NAVIGATION_MAIN_SERVICES_COCHES_MILANUNCIOS_GARAGES_TEXT',
            url: 'NAVIGATION_MAIN_SERVICES_COCHES_MILANUNCIOS_GARAGES_URL'
          }
        ]
      }
    ]
  }
]

/**
 * @exports cTA
 */
export const cTA = {
  text: 'NAVIGATION_CTA_COCHES_TEXT',
  url: 'NAVIGATION_CTA_COCHES_URL'
}

/**
 * @exports cTALogin
 */
export const cTALogin = {
  text: 'NAVIGATION_CTA_LOGIN_COCHES_TEXT',
  loginModalAction: true
}

export const userArea = {
  menuHead: {
    ...USER_EDIT_LINK
  },
  menuItems: [
    {
      ...USER_FAVORITES_LINK,
      iconName: 'IconHeartEmpty'
    },
    {
      ...USER_ALERTS_LINK,
      iconName: 'IconBell',
      hasNotifications: true
    },
    {
      ...USER_MESSAGES_LINK,
      iconName: 'IconMail',
      hasNotifications: true
    },
    {
      ...USER_ADS_LINK,
      iconName: 'IconAdCar'
    },
    {
      ...USER_LOGOUT_LINK,
      iconName: 'IconLogout'
    }
  ]
}

/**
 * @exports user
 */
export const user = {
  hideNavUserInMobile: false,
  loggedIn: [
    {
      text: 'NAVIGATION_USER_COCHES_EDIT_TEXT',
      ...USER_EDIT_LINK,
      icon: 'userFilled'
    },
    {
      ...USER_FAVORITES_LINK,
      icon: 'heartFull'
    },
    {
      id: 'unseenSavedSearches',
      ...USER_ALERTS_LINK,
      icon: 'bellCheck',
      notifications: DEFAULT_NOTIFICATIONS
    },
    {
      id: 'unreadMessages',
      ...USER_MESSAGES_LINK,
      icon: 'comments',
      notifications: DEFAULT_NOTIFICATIONS
    },
    {
      id: 'pendingPta',
      ...USER_ADS_LINK,
      icon: 'carCheck',
      notifications: DEFAULT_NOTIFICATIONS
    },
    {
      ...cTA,
      icon: 'ad-car'
    },
    {
      ...USER_LOGOUT_LINK,
      icon: 'logout'
    }
  ],
  loggedOut: [
    {
      text: 'NAVIGATION_USER_COCHES_SIGN_IN_TEXT',
      url: 'NAVIGATION_USER_COCHES_SIGN_IN_URL',
      icon: 'userFilled'
    },
    {
      text: 'NAVIGATION_USER_COCHES_FAVORITES_TEXT',
      url: 'NAVIGATION_USER_COCHES_FAVORITES_URL',
      icon: 'heartFull'
    },
    {
      text: 'NAVIGATION_USER_COCHES_ALERTS_TEXT',
      url: 'NAVIGATION_USER_COCHES_ALERTS_URL',
      icon: 'bellCheck'
    },
    {
      text: 'NAVIGATION_USER_COCHES_MESSAGES_TEXT',
      url: 'NAVIGATION_USER_COCHES_MESSAGES_URL',
      icon: 'comments'
    },
    {
      id: 'pendingPta',
      text: 'NAVIGATION_USER_COCHES_ADS_TEXT',
      url: 'NAVIGATION_USER_COCHES_ADS_URL',
      icon: 'carCheck',
      notifications: DEFAULT_NOTIFICATIONS
    },
    {
      ...cTA,
      icon: 'ad-car'
    },
    {
      text: 'NAVIGATION_USER_COCHES_PROFESSIONAL_TEXT',
      url: 'NAVIGATION_USER_COCHES_PROFESSIONAL_URL',
      icon: 'certificationLabel'
    }
  ]
}
